function getEventFileInput(evt: Event): HTMLInputElement | null {
    const currentTarget = evt.currentTarget;
    const target = evt.target;

    const input =
        currentTarget instanceof HTMLInputElement ? currentTarget : target instanceof HTMLInputElement ? target : null;

    if (input?.type !== 'file') {
        return null;
    }

    return input;
}

// ----------------------------------------------------------------------------

export default getEventFileInput;
